export default __webpack_public_path__ + "static/media/Icon of the Blood God.29f176a7.jpg";